import React from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';


// Placeholder image imports (replace with actual image paths)
import RishabhImage from '../images/Rishabh-Kumar.jpg';
import ShyamImage from '../images/shyam.jpg';

interface Mentor {
  name: string;
  image: string;
  description: string;
}

const Mentors: React.FC = () => {
  const mentors: Mentor[] = [
    {
      name: 'Dr. Rishabh Kumar',
      image: RishabhImage,
      description:
        'Dr. Rishabh Kumar is a wish to make a just society with work on education, social awareness, poverty alleviation, healthcare, blood donation. He has a experience of more than 3 years as programme officer of Nation Service Scheme at G D Binani P G College Mirzapur. He is serving as district nodal officer of Mirzapur at NSS. He has also worked as nodal officer of SIFPSA in Mirzapur. He has completed physical health and mental health projects of SIFPSA focussing on adolescent and youth. Currently he is working as assistant professor of History at G D Binani P G College Mirzapur. Previously he worked as entertainment tax inspector at UP government as lower PCS officer.',
    },
    {
      name: 'Shyam Sunder Kumar',
      image: ShyamImage,
      description:
        'I have more than 15 years of experience in IT, but beyond working with IT professionals, I have also been deeply involved in NGO work. One of my most impactful experiences was visiting NIMHANS Bangalore, where I had the opportunity to work with special children alongside my office team. However, I see this as just a small step in my journey to connect with people—it was only the beginning, and so many areas remain untouched. Now, I am determined to expand my efforts, focusing on crucial areas such as education, environmental protection, and humanitarian aid for the hungry. We are not just making an effort—we are starting a revolution. Our mission is to ensure that no one goes hungry and that education becomes accessible to everyone.',
    },
  ];

  return (
    <section className="mentors-section">
      <Container>
        <h1 className="mentors-title text-center mb-5 mt-5">Our Esteemed Mentors</h1>
        {mentors.map((mentor, index) => {
          const backgroundColor = index === 0 ? '#f5f6fa' : '#e8ecf1'; // Professional gradient-like colors
          return (
            <div
              key={index}
              className="mentor-section mb-5 p-5"
              style={{ backgroundColor }}
            >
              <Row className={`align-items-center ${index % 2 !== 0 ? 'flex-row-reverse' : ''}`}>
              <Col md={5} className="text-center">
                <div className="mentor-image">
                  <Image
                    src={mentor.image}
                    alt={mentor.name}
                    className="mentor-image"
                    onError={(e) => {
                      (e.target as HTMLImageElement).src = 'https://via.placeholder.com/300x300?text=No+Image';
                    }}
                  />
                </div>
              </Col>
              <Col md={7}>
                <div className="mentor-info">
                  <h2 className="mentor-name">{mentor.name}</h2>
                  <p className="mentor-description">{mentor.description}</p>
                </div>
              </Col>
            </Row>
            </div>
          );
        })}
      </Container>
    </section>
  );
};

export default Mentors;